import {
    Component,
    Input,
    OnInit,
    OnDestroy,
    HostListener,
    EventEmitter,
    Output,
    // AnimationStyles,
    ViewChild,
    ElementRef,
    AfterViewInit,
    ViewEncapsulation
} from '@angular/core';

import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';

import {of, Subject, Subscription, switchMap } from 'rxjs';

import { TagsListFilterRequest } from '../../models/remote.request/TagsListFilterRequest';
import { Tag } from '../../models/domain/Tag';

import { NotificationService } from '../../services/notification/notification.service';
import { WebAccessService } from '../../services/web.access/web-access.service';

@Component({
    selector: 'tk-tag-picker',
    styleUrls: ['./tag-picker.component.less'],
    templateUrl: './tag-picker.component.html',
    encapsulation: ViewEncapsulation.None
})
export class TagPickerComponent implements OnInit, AfterViewInit, OnDestroy {

    @Input() public tagType?: number;

    @Output()
    onHeightChanged: EventEmitter<number> = new EventEmitter<number>();

    @Input() public numTagsToShow = 10000;

    private numberOfTagsInUsed = 5;

    @Input()
    public mode = 'lite';

    @Output() public onSelectedTags: EventEmitter<any> = new EventEmitter<any>();

    @ViewChild('entry') entryRef?: ElementRef;

    public form?: FormGroup;

    private allTags: Tag[] = [];

    public availableTags: Tag[] = [];

    @Input()
    public selectedTags: Tag[] = [];

    public lastUsed: number[] = [];

    public lastUsedTags: Tag[] = [];
    public filteredTags: Tag[] = [];

    private tagsSub?: Subscription;

    public isEntryVisible = false;

    private isEntryVisibleStream: Subject<boolean> = new Subject<boolean>();

    private isEntryVisibleSub?: Subscription;

    public availableTagIndex = 0;

    public isFocusOutBlocked = false;

    public entryControl: FormControl;

    public entryControlText: string = '';

    public tagListHeight = 150;
    isLoading = false;
    areTagsLoaded = false;

    constructor(
        private $fb: FormBuilder,
        private $msg: NotificationService,
        private $webAccess: WebAccessService,
        private $element: ElementRef
    ) {
        this.entryControl = this.$fb.control(null);
    }


    /**
     * Ng on init lifecycle hook
     */
    public ngOnInit(): void {

        // setTimeout(() => this.showEntry(), 1000);

        // zmiany na entry
        this.entryControl.valueChanges.subscribe(change => {

            this.entryControlText = (change || '').toLowerCase();

            const unselectedTags = this.allTags.filter(x => !this.selectedTags.some(y => y.Id === x.Id)
                && !this.lastUsed.some(y => y === x.Id));

            this.availableTags = unselectedTags.filter(tag => tag.L.toLowerCase().indexOf(this.entryControlText!) !== -1)
                .slice(0, this.numTagsToShow);

            // pobranie ostatnio uztych
            const lastUsedTags = this.allTags
                .filter(x => this.lastUsed.some(y => y === x.Id))
                .filter(tag => tag.L.toLowerCase().indexOf(this.entryControlText!) !== -1);

            lastUsedTags.sort((x, y) => x.L.localeCompare(y.L));
            lastUsedTags.forEach(tag => {
                (<any>tag).LastUsed = true;
            });

            this.availableTags = lastUsedTags.concat(this.availableTags);

            let i = 0;
            this.availableTags.forEach(tag => {
                (<any>tag).Index = i++;
            });

            this.lastUsedTags = this.availableTags.filter(t => (<any>t).LastUsed === true);
            this.filteredTags = this.availableTags.filter(t => (<any>t).LastUsed !== true);

            this.availableTagIndex = 0;

            this.emitHeightChange();

        });
        // zaladowanie listy tagow

        this.emitHeightChange();
    }

    private loadTags() {
      this.isLoading = true;

      of(<TagsListFilterRequest>{Phrase: '', TagType: this.tagType})
        .pipe(switchMap(request => this.$webAccess.GetTagsListByFilter(request)))
        .subscribe(response => {
          this.allTags = response.Result;
          this.allTags.sort((x, y) => x.L.localeCompare(y.L));
          this.isLoading = false;
          this.areTagsLoaded = true;
          this.isEntryVisibleStream.next(true);
        });
    }

    /**
     * Ng after view init lifecycle hook
     */
    public ngAfterViewInit(): void {

        // Build and subscribe stream of entry's visibility changes
        this.isEntryVisibleSub = this.isEntryVisibleStream.subscribe(isVisible => {
            this.isEntryVisible = isVisible;
            if (isVisible) {
                setTimeout(() => {
                    this.entryControl.setValue('');
                    this.entryRef?.nativeElement.focus();
                }, 0);
            } else {
                this.entryControl.setValue('');
            }

            this.emitHeightChange();
        });

        this.emitHeightChange();
    }


    /**
     * Ng on destroy lifecycle hook
     */
    public ngOnDestroy(): void {

        if (this.tagsSub) {
            this.tagsSub.unsubscribe();
        }
        if (this.isEntryVisibleSub) {
            this.isEntryVisibleSub.unsubscribe();
        }
    }


    /**
     * Handles keyboard's keydown event
     * @param event keyboard event
     */
    @HostListener('keydown', ['$event'])
    public onKeyDown(event: KeyboardEvent): void {

        switch (event.keyCode) {

            // case 13:  // Enter

            //     this.selectTag(this.availableTagIndex);
            //     break;

            // case 38:  // Arrow down

            //     this.availableTagIndex--;
            //     if (this.availableTagIndex < 0) {
            //         this.availableTagIndex = 0;
            //     }

            //     document.getElementById('tag-available').scrollTop = 0;

            //     break;

            // case 40:  // Arrow up

            //     this.availableTagIndex++;
            //     if (this.availableTagIndex > this.numTagsToShow - 1) {
            //         this.availableTagIndex = this.numTagsToShow - 1;
            //     }

            //     // document.getElementById('tag-available').scrollTop = 0;

            //     break;

            case 27:  // Escape

                this.isEntryVisibleStream.next(false);
                break;

        }
    }

    /**
     * zdarzenie opuszczenia okna edycji tagolw
     */
    @HostListener('focusout', ['$event'])
    public onFocusOut(event: Event): void {
        this.closeEntry();
    }

    closeEntry() {
        setTimeout(() => {
            if (this.isFocusOutBlocked !== true) {
                this.isEntryVisibleStream.next(false);
            }
        }, 300);
    }


    /**
     * blokowanie focus out
     */
    public blockFocusOut(flag: boolean) {
        this.isFocusOutBlocked = flag;
    }

    /**
     * Shows entry
     */
    public showEntry(): void {
      if (!this.areTagsLoaded)
        this.loadTags();
      else
        this.isEntryVisibleStream.next(true);
    }

    private clearHistory() {
        while (this.lastUsed.length >= this.numberOfTagsInUsed) {
            const TagId = this.lastUsed.shift();
            const idx = this.availableTags.findIndex(i => (<any>i).TagId === TagId);
            const p = this.availableTags[idx];
            (<any>p).LastUsed = false;
        }
    }

    /**
     * Removes selected tag with given index
     * @param index index of selected tag to remove
     */
    public removeTag(index: number): void {

        setTimeout(() => {
            const removed = this.selectedTags[index];
            this.selectedTags.splice(index, 1);
            this.selectedTags.sort((x, y) => x.L.localeCompare(y.L));
            this.clearEntry();
            this.onSelectedTags.emit(this.selectedTags);
            this.emitHeightChange();
        }, 100);
    }


    /**
     * Removes all selected tags
     */
    public removeAllTags(): void {
        setTimeout(() => {
            this.availableTags = this.allTags.slice();
            this.availableTags.sort((x, y) => x.L.localeCompare(y.L));
            this.selectedTags = [];
            this.onSelectedTags.emit(this.selectedTags);
            this.emitHeightChange();
        }, 100);
    }


    /**
     * Selects available tag with given index
     * @param index index of avaiable tag to select
     */
    public selectTag(index: number): void {

        setTimeout(() => {

            // wybranie po tak
            const selectedIdx = this.availableTags.findIndex(i => (<any>i).Index === index);
            const selected = this.availableTags[selectedIdx];

            if (selected) {

                // dodanie do wybranych
                // jezeli dany tag jest juz wybrany to nie dodajemy
                const _selectedIdx = this.selectedTags.findIndex(i => (<any>i).Index === index);
                if (!(_selectedIdx >= 0)) {
                    this.selectedTags.push(selected);
                    this.selectedTags.sort((x, y) => x.L.localeCompare(y.L));
                }

                this.clearHistory();

                // obsluga ostatnio uzytych
                if (this.lastUsed.indexOf(selected.Id) === -1) {
                    this.lastUsed.push(selected.Id);
                }



                // wyslanie info
                this.onSelectedTags.emit(this.selectedTags);
                this.isEntryVisibleStream.next(false);

            }


            this.emitHeightChange();

        }, 100);
    }


    public emitHeightChange() {
        // pobranie wysokosci elementu
        const height = this.$element.nativeElement.offsetParent.clientHeight;
        this.onHeightChanged.emit(height);

        // obliczenie pokaza rozwiniecia
        if (this.mode === 'lite') {
            const bb = this.$element.nativeElement.getBoundingClientRect();
            this.tagListHeight = document.documentElement.clientHeight - bb.top - 40;

        } else {
            this.tagListHeight = 150;
        }

    }

    public getLastUsed() {

    }

    public getToSelect() {

    }

    /**
     * Clears entry's value
     */
    public clearEntry(): void {

        this.entryControl.setValue('');
    }

    public clearAndCloseEntry() {
        this.clearEntry();
        this.closeEntry();
    }
}
